import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTimesheetCreate,
  detail: routeTimesheetDetail,
  home: routeTimesheetsHome,
  root: routeTimesheetsRoot,
} = createDoctypeRoutes({
  createName: 'new-timesheet',
  createPath: 'new-timesheet',
  detailName: 'timesheetDetail',
  doctype: DOCTYPES.TIMESHEET,
  homeName: 'timesheets',
  path: 'timesheets',
  views: {
    create: async () => await import('@/components/viewsExternal/timesheets/AddTimesheet.vue'),
    detail: async () => await import('@/components/viewsExternal/timesheets/ViewTimesheet.vue'),
    list: async () => await import('@/components/viewsExternal/timesheets/TimesheetView.vue'),
  },
})

export { routeTimesheetCreate, routeTimesheetDetail, routeTimesheetsHome, routeTimesheetsRoot }
